import { useQuery } from '@tanstack/react-query';
import { Book, Chapter } from '../types';

// Helper to fetch detailed chapter data
export const fetchChapterDetails = async (
  bookId: number,
  chapterId: number,
): Promise<Chapter> => {
  const url = `/api/v0/fictions/${bookId}/chapters/${chapterId}`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to fetch chapter ${chapterId} for book ${bookId}`);
  }
  const chapter: Chapter = await res.json();
  return { ...chapter, hydrated: true };
};

export const useChapterDetails = (
  book: Book | undefined,
  chapterId: number | undefined,
  options?: { queryKey?: string },
) => {
  const queryKeyPrefix = options?.queryKey || '';
  const bookId = book?.id;

  return useQuery<Chapter, Error>({
    queryKey: queryKeyPrefix
      ? ['chapter', bookId, chapterId, queryKeyPrefix]
      : ['chapter', bookId, chapterId],
    queryFn: () => {
      // These assertions are safe because of the enabled condition
      return fetchChapterDetails(bookId!, chapterId!);
    },
    enabled: !!bookId && !!chapterId,
  });
};
